var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Vue, Component } from "vue-facing-decorator";
import { State } from "vuex-facing-decorator";
import { LoginState } from "@/app/store/modules/login.state";
import store from "@/app/store/store";
import { UsersClient, CompaniesClient, RolesClient, AuthClient, UserModel, UserPasswordModel, CreateUserPasswordCommand, CreateUserCommand, CreateUserModel, UpdateUserCommand, GetCompanyListQuery, RequestUserPasswordResetCommand, UserPasswordResetRequestModel, RoleTypeEnum } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { Alert } from "@/common/utils/alert";
import RouteNames from "@/app/router/routes";
import UserCompanyAccessVue from "@/app/vues/admin/user-company-access.vue";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import { DateHelper } from "@/app/utils/date-helper";
import PasswordLegendVue from "@/app/vues/components/password-legend.vue";
import "@/app/component-hooks";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const userClient = new UsersClient(window.apiUrl);
const roleClient = new RolesClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const authClient = new AuthClient(window.apiUrl);
let UserVue = class UserVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.userId = 0;
        this.loaded = false;
        this.working = false;
        this.changingPassword = false;
        this.generateRandomPassword = false;
        // components
        this.msg = new Alert();
        // models
        this.user = new UserModel();
        this.userPassword = new UserPasswordModel({
            userId: 0,
            password: "",
            passwordConfirmation: ""
        });
        this.authorizedCompanyId = null;
        // arrays
        this.roles = [];
        this.companies = [];
    }
    created() {
        this.userId = parseInt(this.$route.params.id) || 0;
        this.authorizedCompanyId = parseInt(this.$route.params.companyId) || null;
        this.load();
    }
    ;
    mounted() {
        this.setFieldValue("companyIdVisible", this.isNewUser && !this.isPowerShield);
    }
    ;
    removeUsernameSpaces() {
        if (!this.user.userName)
            return;
        this.user.userName = this.user.userName.replace(/\s/g, "");
    }
    ;
    // Mirrors the server-side SmtpUtility.IsValidEmail check used by CreateUserCommandHandler
    // to decide whether an account invitation email can be sent.
    hasValidInvitationEmail() {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const email = (this.user.emailAddress || "").trim();
        const userName = (this.user.userName || "").trim();
        return emailRegex.test(email) || emailRegex.test(userName);
    }
    ;
    // we have to monitor route changes in order to make Vue react to the change
    beforeRouteUpdate(to, from, next) {
        this.userId = parseInt(to.params.id || 0);
        this.user = new UserModel();
        this.get();
        next();
    }
    ;
    load() {
        this.get();
        this.getLookups();
        this.getCompanies();
    }
    ;
    // get
    get() {
        if (this.isNewUser) {
            this.loaded = true;
            this.generateRandomPassword = true;
            let user = new UserModel();
            user.init({});
            this.map(user);
            return;
        }
        if (this.working)
            return;
        this.working = true;
        userClient
            .get(this.userId)
            .then(response => {
            if (!response) {
                this.$router.push({ name: RouteNames.Home });
                return;
            }
            this.loaded = true;
            this.map(response);
            this.setValues({
                userName: this.user.userName,
                role: this.role,
                firstName: this.user.firstName,
                lastName: this.user.lastName,
                email: this.user.emailAddress || undefined,
                mobilePhone: this.user.mobilePhone || undefined,
                workPhone: this.user.workPhone || undefined,
            });
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    getLookups() {
        let promises = [
            roleClient
                .getList(this.isNewUser)
                .then(response => {
                this.roles = [{ value: null, text: TextHelper.emptyListItemName }].concat((response || []).map((item) => {
                    return {
                        value: item.roleId,
                        text: item.roleName
                    };
                }));
                if (this.user.roleId) {
                    this.setFieldValue("role", this.role);
                }
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
        ];
        Promise.all(promises);
    }
    ;
    getCompanies() {
        if (this.isPowerShield)
            return;
        companyClient
            .getListPOST(new GetCompanyListQuery({
            includeDeleted: false,
            keywords: null
        }))
            .then(response => {
            this.companies = [{ value: null, text: TextHelper.emptyListItemName }].concat((response || []).map((item) => {
                return {
                    value: item.companyId,
                    text: item.companyName
                };
            }));
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    map(user) {
        this.user = user;
        this.userPassword.userId = user.userId;
    }
    ;
    // set
    save() {
        if (this.working)
            return;
        if (this.authorizedCompany) {
            this.setFieldValue('authorizedCompanyId', this.authorizedCompany);
        }
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            let promise = () => {
                return this.isNewUser
                    ? userClient.add(new CreateUserCommand({
                        requestModel: new CreateUserModel({
                            userModel: this.user,
                            userPasswordModel: this.userPassword,
                            authorizedCompanyId: this.authorizedCompanyId,
                            sendAccountInvitation: true,
                            generateRandomPassword: this.generateRandomPassword,
                            timezoneOffset: DateHelper.getTimezoneOffset()
                        })
                    }))
                    : userClient.update(this.user.userId, new UpdateUserCommand({ requestModel: this.user }));
            };
            const wasNewUser = this.isNewUser;
            const invitationRequested = wasNewUser && this.generateRandomPassword;
            const invitationEmailInvalid = invitationRequested && !this.hasValidInvitationEmail();
            promise()
                .then(response => {
                this.userId = response;
                this.generateRandomPassword = false;
                this.working = false;
                Notifier.onOk();
                if (invitationEmailInvalid) {
                    Notifier.onWarning("The user was created successfully, however no account invitation email was sent because the email address is invalid. Please update the email address and use \"Reset Password\" to send an invitation.");
                }
                this.get();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        }, () => {
            Notifier.onError("Please check that you have entered all details correctly.");
        });
        handleSubmitAction();
    }
    ;
    archive() {
        if (this.working || this.isNewUser)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this user?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            userClient
                .delete(this.user.userId)
                .then(() => {
                this.user.whenDeleted = new Date();
                Notifier.onOk(`User # ${this.user.userId} has been successfully archived.`);
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    restore() {
        if (this.working || this.isNewUser)
            return;
        userClient
            .restore(this.user.userId)
            .then(() => {
            this.user.whenDeleted = undefined;
            Notifier.onOk(`User # ${this.user.userId} has been successfully restored.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    changePassword() {
        if (this.working || this.isNewUser)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            userClient
                .updatePassword(this.user.userId, new CreateUserPasswordCommand({ requestModel: this.userPassword }))
                .then(() => {
                Notifier.onOk("Your password has been successfuly changed.");
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        }, () => {
            Notifier.onError("Please check that you have correctly entered all password fields.");
        });
        handleSubmitAction();
    }
    ;
    requestPasswordChange() {
        this.changingPassword = !this.changingPassword;
        this.setFieldValue("generatePassword", !this.changingPassword);
        if (this.changingPassword) {
            var self = this;
            setTimeout(function () {
                self.setErrors({
                    password: undefined,
                    passwordConfirmation: undefined
                });
            }, 50);
        }
    }
    ;
    resetPassword() {
        this.$confirmModal.show("Are you sure that you want to reset this user password?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            let command = new RequestUserPasswordResetCommand();
            command.requestModel = new UserPasswordResetRequestModel({
                userName: this.user.userName,
                clearPreviousPassword: true,
                timezoneOffset: DateHelper.getTimezoneOffset()
            });
            authClient
                .requestPasswordReset(command)
                .then(response => {
                Notifier.onOk(`User Password has been Cleared and an email with password recovery link was sent. It will expire in 1 hour.`);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    clear2FAMethod() {
        this.$confirmModal.show("Are you sure that you want to clear the Two Factor Authentication settings for this user?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            userClient
                .clear2FAMethod(this.userId)
                .then(() => {
                Notifier.onOk("Two Factor Authentication Method has been cleared!");
                this.user.twoFactorAuthMethod = 0;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    goBack() {
        this.$router.back();
    }
    ;
    // computed
    get pageTitle() {
        return this.isNewUser ? "New User" : this.userTitle;
    }
    get userTitle() {
        if (!this.user)
            return "";
        return TextHelper.getRecordTitle(this.user.userName || "", this.isUserArchived);
    }
    get isNewUser() {
        return !this.userId;
    }
    get isUserArchived() {
        if (!this.user)
            return false;
        return this.user.whenDeleted != null;
    }
    // return the expected scope for password fields
    get currentScope() {
        if (this.isNewUser)
            return "userForm";
        return "passwordForm";
    }
    ;
    get isClient() {
        return this.user.roleId == RoleTypeEnum.Client
            || this.user.roleId == RoleTypeEnum.ClientAdministrator
            || this.user.roleId == RoleTypeEnum.ClientInstaller ? true : false;
    }
    ;
    get isClientAdmin() {
        return this.user.roleId == RoleTypeEnum.ClientAdministrator ? true : false;
    }
    ;
    get isPowerShield() {
        return this.loginState.isPowerShield;
    }
    ;
    get roleId() {
        return this.user.roleId;
    }
    ;
    get role() {
        return this.roles.filter(item => {
            return (item.value == this.user.roleId);
        })[0] || null;
    }
    ;
    set role(item) {
        if (!item)
            return;
        this.user.roleId = item.value;
    }
    ;
    get authorizedCompany() {
        return this.companies.filter(item => {
            return (item.value == this.authorizedCompanyId);
        })[0] || null;
    }
    ;
    set authorizedCompany(item) {
        this.setFieldValue("authorizedCompanyId", item);
        if (!item)
            return;
        this.authorizedCompanyId = item.value;
    }
    ;
    get selectPlaceholder() {
        return TextHelper.emptyListItemName;
    }
    ;
    get userHasLoggedIn() {
        return this.user.whenLastLoggedIn ? true : false;
    }
    ;
    get whenLastLoggedInString() {
        return DateHelper.convertToFriendlyMomentTimeString(this.user.whenLastLoggedIn || null);
    }
    ;
    get hasTwoFactorAuth() {
        if (!this.user)
            return false;
        return this.user.twoFactorAuthMethod > 0;
    }
    get isThirdPartyAuth() {
        return store.getters["appConfigModule/isThirdPartyAuth"];
    }
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], UserVue.prototype, "loginState", void 0);
UserVue = __decorate([
    Component({
        name: "UserVue",
        components: {
            PasswordLegendVue,
            UserCompanyAccessVue
        },
        setup() {
            const { errors, handleSubmit, setErrors, defineInputBinds, defineComponentBinds, setValues, setFieldValue } = useForm({
                validationSchema: yup.object({
                    userName: yup.string().trim().required(),
                    role: yup.object().listOptionRequired(),
                    firstName: yup.string().trim().required(),
                    lastName: yup.string().trim().required(),
                    email: yup.string().email(),
                    mobilePhone: yup.string().phoneNumber(),
                    workPhone: yup.string().phoneNumber(),
                    companyIdVisible: yup.boolean(),
                    authorizedCompanyId: yup.object().when("companyIdVisible", {
                        is: true,
                        then: (schema) => schema.listOptionRequired(),
                    }),
                    generatePassword: yup.boolean(),
                    password: yup.string().when("generatePassword", {
                        is: false,
                        then: (schema) => schema.customPassword(),
                    }),
                    passwordConfirmation: yup.string().when("generatePassword", {
                        is: false,
                        then: (schema) => schema.required().oneOf([yup.ref('password')]),
                    }),
                }),
            });
            const userNameVal = defineInputBinds('userName');
            const roleVal = defineComponentBinds('role');
            const firstNameVal = defineInputBinds('firstName');
            const lastNameVal = defineInputBinds('lastName');
            const emailVal = defineInputBinds('email');
            const mobilePhoneVal = defineInputBinds('mobilePhone');
            const workPhoneVal = defineInputBinds('workPhone');
            const authorizedCompanyIdVal = defineComponentBinds('authorizedCompanyId');
            const generatePasswordVal = defineComponentBinds('generatePassword');
            const passwordVal = defineInputBinds('password');
            const passwordConfirmationVal = defineInputBinds('passwordConfirmation');
            return {
                errors,
                handleSubmit,
                setValues,
                setFieldValue,
                setErrors,
                roleVal,
                userNameVal,
                firstNameVal,
                lastNameVal,
                emailVal,
                mobilePhoneVal,
                workPhoneVal,
                authorizedCompanyIdVal,
                generatePasswordVal,
                passwordVal,
                passwordConfirmationVal
            };
        }
    })
], UserVue);
export default UserVue;
